export default (params) => ({
  trigger: {
    name: 'content_blocks.text_image_video.select_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'text',
          'text_and_image',
          'text_and_image_two_column',
          'text_and_image_three_column',
          'text_and_video',
          'video',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
